import {
  AccountBalance as AccountBalanceIcon,
  Groups as GroupsIcon,
  Inventory as InventoryIcon,
  Payments as PaymentsIcon,
  PointOfSale as PointOfSaleIcon,
  Receipt as ReceiptIcon,
  Tune as TuneIcon,
  TrendingUp as TrendingUpIcon,
  Checklist as ChecklistIcon,
  Engineering as EngineeringIcon,
} from "@mui/icons-material";

import {
  AccountingActionEnum,
  AccountingActionCategory,
} from "./accounting-action-enum";

export const ActionSectionMapping = Object.freeze({
  [AccountingActionCategory.GOODS_AND_SERVICES]: [
    {
      title: "Barang & Jasa",
      icon: <InventoryIcon />,
      actions: [
        AccountingActionEnum.INVENTORY,
        AccountingActionEnum.SALES_REVENUE,
        AccountingActionEnum.SALES_RETURN,
        AccountingActionEnum.SALES_DISCOUNT,
        AccountingActionEnum.GOODS_IN_TRANSIT,
        AccountingActionEnum.COST_OF_GOODS_SOLD,
        AccountingActionEnum.PURCHASE_RETURN,
        AccountingActionEnum.EXPENSE,
        AccountingActionEnum.UNBILLED_PAYABLES,
      ],
    },
  ],
  [AccountingActionCategory.COMPANY]: [
    {
      title: "Neraca",
      icon: <AccountBalanceIcon />,
      actions: [
        AccountingActionEnum.OPENING_BALANCE_EQUITY,
        AccountingActionEnum.RETAINED_EARNINGS,
      ],
    },
    {
      title: "Laba/Rugi",
      icon: <TrendingUpIcon />,
      actions: [AccountingActionEnum.INCOME_TAX_EXPENSE],
    },
    {
      title: "Penggajian Karyawan",
      icon: <GroupsIcon />,
      actions: [
        AccountingActionEnum.PPH21_PAYABLE,
        AccountingActionEnum.PENSION_PAYABLE,
        AccountingActionEnum.HEALTH_INSURANCE_PAYABLE,
      ],
    },
    {
      title: "Peminjaman Karyawan",
      icon: <GroupsIcon />,
      actions: [
        AccountingActionEnum.EMPLOYEE_LOAN_RECEIVABLE,
        AccountingActionEnum.LOAN_INTEREST_RECEIVABLE,
        AccountingActionEnum.DEFERRED_INTEREST_INCOME,
        AccountingActionEnum.LOAN_INTEREST_INCOME,
        AccountingActionEnum.LOAN_PENALTY_INCOME,
      ],
    },
  ],
  [AccountingActionCategory.SALES_PURCHASE]: [
    {
      title: "Penerimaan/Pembayaran",
      icon: <PaymentsIcon />,
      actions: [AccountingActionEnum.PAYMENT_DISCOUNT],
    },
    {
      title: "Faktur Pembelian",
      icon: <ReceiptIcon />,
      actions: [AccountingActionEnum.TAX_ROUNDING_DIFFERENCE],
    },
  ],
  [AccountingActionCategory.INVENTORY]: [
    {
      title: "Penyesuaian Persediaan",
      icon: <TuneIcon />,
      actions: [AccountingActionEnum.INVENTORY_ADJUSTMENT],
    },
    {
      title: "Perintah Stok Opname",
      icon: <ChecklistIcon />,
      actions: [AccountingActionEnum.STOCK_OPNAME_VARIANCE],
    },
    {
      title: "Pekerjaan Pesanan",
      icon: <EngineeringIcon />,
      actions: [
        AccountingActionEnum.WORK_IN_PROGRESS,
        AccountingActionEnum.JOB_COST_VARIANCE,
      ],
    },
  ],
  [AccountingActionCategory.CUSTOMER]: [
    {
      title: "Kustomisasi Akun Penjualan",
      icon: <PointOfSaleIcon />,
      actions: [
        AccountingActionEnum.ACCOUNTS_RECEIVABLE,
        AccountingActionEnum.SALES_DOWN_PAYMENT,
        AccountingActionEnum.SALES_REVENUE,
        AccountingActionEnum.ITEM_DISCOUNT,
        AccountingActionEnum.COST_OF_GOODS_SOLD,
        AccountingActionEnum.SALES_RETURN,
        AccountingActionEnum.SALES_DISCOUNT,
      ],
    },
  ],
  [AccountingActionCategory.SUPPLIER]: [
    {
      title: "Akun Pembelian",
      icon: <PointOfSaleIcon />,
      actions: [
        AccountingActionEnum.ACCOUNTS_PAYABLE,
        AccountingActionEnum.PURCHASE_DOWN_PAYMENT,
      ],
    },
  ],
});

/**
 * Actions that must have at least one COA mapped before preferences can be
 * saved.
 */
export const REQUIRED_ACTIONS = new Set([
  AccountingActionEnum.OPENING_BALANCE_EQUITY,
  AccountingActionEnum.RETAINED_EARNINGS,
]);

/**
 * Actions that only accept a single COA (not multiple).
 * All other actions accept multiple COAs.
 */
export const SINGLE_SELECT_ACTIONS = new Set([
  AccountingActionEnum.OPENING_BALANCE_EQUITY,
  AccountingActionEnum.RETAINED_EARNINGS,
  AccountingActionEnum.TAX_ROUNDING_DIFFERENCE,
]);

/**
 * Actions in the customer (Kustomisasi Akun Penjualan) context that accept
 * multiple COAs. All other customer actions are single-select.
 */
export const CUSTOMER_MULTI_SELECT_ACTIONS = new Set([
  AccountingActionEnum.ACCOUNTS_RECEIVABLE,
  AccountingActionEnum.SALES_DOWN_PAYMENT,
]);

/**
 * Actions in the supplier (Akun Pembelian) context that accept multiple COAs.
 * Both supplier actions are multi-select.
 */
export const SUPPLIER_MULTI_SELECT_ACTIONS = new Set([
  AccountingActionEnum.ACCOUNTS_PAYABLE,
  AccountingActionEnum.PURCHASE_DOWN_PAYMENT,
]);
